// Finding the booking a conversation is about.
//
// There is no conversation→booking link in the archive: the index joins mail
// to a booking the other way round (`GET /email-inbox?booking_id=…` builds
// its search terms FROM a booking). So the reference is read out of what the
// correspondence itself says, which works because every template the dash
// sends puts it in the subject.
//
// IT IS A GUESS, AND THE CALLER MUST TREAT IT AS ONE. A conversation with no
// reference in it resolves to nothing and the booking panel is simply absent
// — that is the honest outcome, not an error.

/**
 * `PU_DASH_1699241`, `PU_WEB_3600513` — the source segment is letters because
 * there are several (DASH, WEB, and partner sources), and it is NOT anchored
 * to a known list so a source added tomorrow still resolves.
 */
const REFERENCE = /\bPU_[A-Z]+_\d+\b/i;

/**
 * The first booking reference in some text, upper-cased, or null.
 *
 * Upper-cased because the token is canonically upper and an agent's reply may
 * quote it in any case; the server matches it case-insensitively either way,
 * but the value is also what gets DISPLAYED and compared.
 */
export function extractBookingReference(text) {
  const found = REFERENCE.exec(String(text ?? ''));
  return found ? found[0].toUpperCase() : null;
}

/**
 * The reference a whole conversation is about.
 *
 * THE TITLE FIRST, then the messages oldest-first. The subject is where a
 * template puts it and it survives the whole thread, so it is both the most
 * likely place and the most stable; a body is searched only as a fallback,
 * and the OLDEST message wins because a long thread can come to mention a
 * second booking later and the one it is ABOUT is the one it started on.
 */
export function conversationBookingReference(conversation) {
  if (!conversation) return null;

  const fromTitle = extractBookingReference(conversation.title);
  if (fromTitle) return fromTitle;

  const messages = conversation.messages || [];
  for (let i = 0; i < messages.length; i += 1) {
    const message = messages[i];
    const found = extractBookingReference(message?.email?.subject)
      || extractBookingReference(message?.preview);
    if (found) return found;
  }

  return null;
}

export default extractBookingReference;
